import { Link } from 'react-router-dom';
import { openCookieSettings } from './CookieConsent';

const links = [
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
  { to: '/contact', label: 'Contact' },
];

// Global footer: RAWG attribution (required by their API terms) + compact legal links on every route.
export const Footer = () => (
  <footer
    className="border-t border-[#E4E4E7] bg-white px-6 py-3 text-xs text-[#71717A] flex flex-col sm:flex-row items-center justify-center gap-x-6 gap-y-2"
    data-testid="global-footer"
  >
    <p>
      Data &amp; images provided by{' '}
      <a href="https://rawg.io" target="_blank" rel="noopener noreferrer" className="text-[#0047FF] hover:underline font-medium" data-testid="rawg-attribution-link">
        RAWG
      </a>
    </p>
    <nav className="flex items-center gap-4" aria-label="Legal">
      {links.map((l) => (
        <Link key={l.to} to={l.to} className="hover:text-[#0047FF] transition-colors" data-testid={`global-footer-${l.label.toLowerCase()}`}>
          {l.label}
        </Link>
      ))}
      <button type="button" onClick={openCookieSettings} className="hover:text-[#0047FF] transition-colors" data-testid="global-footer-cookie-settings">
        Cookie settings
      </button>
    </nav>
  </footer>
);
